export const manuals = [
  { number: "01", title: "Hogar", description: "Pisos, baños, vidrios, desinfectantes y limpieza doméstica." },
  { number: "02", title: "Ropa y textiles", description: "Detergentes, suavizantes, quitamanchas y preparaciones textiles." },
  { number: "03", title: "Cocina y desengrasantes", description: "Lavavajillas, abrillantadores, desengrasantes y más." },
  { number: "04", title: "Auto detailing", description: "Limpieza, mantenimiento y estética automotor." },
  { number: "05", title: "De tu cocina al negocio", description: "Contenido para empezar a pensar lo que fabricás como un producto comercializable." },
];

export const categories = [
  { title: "Hogar", description: "Pisos, baños, vidrios, desinfectantes, multiuso y más." },
  { title: "Ropa y textiles", description: "Detergentes, suavizantes, quitamanchas y cuidado textil." },
  { title: "Cocina y desengrasantes", description: "Lavavajillas, abrillantadores, desengrasantes y productos específicos." },
  { title: "Auto detailing", description: "Shampoo automotor, ceras, productos para llantas y cuidado del vehículo." },
];

export const bonuses = [
  {
    number: "BONO 01",
    title: "Directorio de proveedores",
    description: "Proveedores por provincia en Argentina.",
    image: "https://cdn.magicpatterns.com/uploads/kqxm4G76RrFMPqdWQZm2vC/ChatGPT_Image_21_sept_2026,_21_52_20.webp",
  },
  {
    number: "BONO 02",
    title: "Planilla Excel de costos y precios",
    description: "Organizá costos y trabajá el precio de tus productos.",
    image: "https://cdn.magicpatterns.com/uploads/bddcj2KVRCVqQJx9AtmTUP/ChatGPT_Image_21_sept_2026,_21_53_07.webp",
  },
  {
    number: "BONO 03",
    title: "Plantillas de etiquetas profesionales",
    description: "Diseños editables para personalizar tus productos.",
    image: "https://cdn.magicpatterns.com/uploads/aCqNUnEU5ry7J6RsXi4p1a/ChatGPT_Image_21_sept_2026,_21_56_24.webp",
  },
  {
    number: "BONO 04",
    title: "Detergente · Lote de 100 kg",
    description: "Fórmula completa para conocer el proceso de elaboración a mayor escala.",
    image: "https://cdn.magicpatterns.com/uploads/mgjqSKRkdUTXEoH8Gp3gGN/ChatGPT_Image_21_sept_2026,_21_57_14.webp",
  },
  {
    number: "BONO 05",
    title: "Fórmulas automotrices",
    description: "Manual exclusivo de fórmulas para limpieza y cuidado automotor.",
    image: "https://cdn.magicpatterns.com/uploads/p9ZMxH7xPZvFEh6HmVbvHL/ChatGPT_Image_21_sept_2026,_21_59_53.webp",
  },
];

export const faqs = [
  ["¿El producto es físico?", "No. Fórmula Emprendedora es un producto 100% digital. No se realizan envíos físicos."],
  ["¿Cómo recibo el material?", "Una vez confirmado el pago, recibís las instrucciones para acceder al contenido digital."],
  ["¿Necesito experiencia previa?", "No necesitás experiencia previa para acceder al material. Podés avanzar y consultar las fórmulas a tu ritmo."],
  ["¿Incluye más de 400 fórmulas?", "Sí. El material reúne más de 400 fórmulas distribuidas entre las diferentes categorías incluidas."],
  ["¿Puedo verlo desde el celular?", "Sí. Podés consultar el contenido desde celular, tablet o computadora."],
  ["¿Los 5 bonos están incluidos?", "Sí. Los cinco bonos indicados en esta oferta están incluidos sin costo adicional."],
  ["¿Incluye proveedores de Argentina?", "Sí. El Bono 01 incluye el directorio de proveedores por provincia incluido en el paquete."],
  ["¿El acceso vence?", "No. El acceso ofrecido es de por vida."],
  ["¿Tengo garantía?", "Sí. La compra cuenta con una garantía de 14 días según las condiciones informadas en el sitio."],
] as const;

export const mainBookImage = "https://cdn.magicpatterns.com/uploads/2pQxj6BjPteABrLFxsu3Wx/ChatGPT_Image_21_sept_2026,_22_11_17.webp";
export const megaKitCollageImage = "https://cdn.magicpatterns.com/uploads/kkbqJgPTetTZJJYR1v4DYe/ChatGPT_Image_22_sept_2026,_11_21_08.webp";
export const heroKitImage = "https://cdn.magicpatterns.com/uploads/q2oVZTs4pgeCGfJubuRUq8/ChatGPT_Image_21_sept_2026,_23_21_20.webp";
export const finishedProductImages = [
  { src: "https://cdn.magicpatterns.com/uploads/4upc3KXxXnDVT3AwDX547p/WhatsApp_Image_2026-09-21_at_8.48.52_PM.jpg", alt: "Ejemplo de suavizante fabricado" },
  { src: "https://cdn.magicpatterns.com/uploads/46xjgHEK6PCLrqJECWVRJb/WhatsApp_Image_2026-09-21_at_8.48.52_PM_(2).jpg", alt: "Ejemplo de detergente fabricado" },
  { src: "https://cdn.magicpatterns.com/uploads/wT5VBaJcN4nQjnubr6wF1e/WhatsApp_Image_2026-09-21_at_8.48.52_PM_(1).jpg", alt: "Ejemplo de lavandina fabricada" },
] as const;
